import { lazy } from 'react';
import EmailIcon from '@/components/PlatformIcon/icons/email.svg?react';
import { PlatformTypes } from '@/types/gql.generated';
import { useAlwaysAvailable } from './availability.lib';
import type { DestinationModule } from './types';

// The form only mounts once a drawer opens, so it loads lazily (interaction
// registry precedent) and the entry stays cheap for data-only consumers.
const EventEmailForm = lazy(() =>
  import('../components/EmailMenu/EventEmailForm').then((module) => ({
    default: module.EventEmailForm,
  }))
);

// A compose flow rather than a calendar link: pickers offer it as a per-event
// destination, and it is the only one whose success reads "Sent!". The send
// itself is recorded server-side as a subscription, which keeps the invite
// updated when the event changes.
export const emailDestination: DestinationModule = {
  platform: PlatformTypes.Email,
  behavior: 'copy',
  name: 'Email',
  addLabel: 'Email invite',
  successLabel: 'Sent! 🎉',
  description:
    'Emails you a calendar invite that updates automatically if the event changes.',
  syncKind: 'sync',
  syncTagPreposition: 'via',
  icon: { kind: 'svgIcon', component: EmailIcon },
  isPinnable: true,
  persistedByServer: true,
  statusSource: 'emailSubscription',
  useIsAvailable: useAlwaysAvailable,
  ExportForm: EventEmailForm,
};
